/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useRef, useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {IReceptionCreate, defaultReceptionCreate} from './IAppModels'
import {StepperComponent} from '../../../../../../_metronic/assets/ts/components'
import {KTIcon} from '../../../../../../_metronic/helpers'
import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {Step3} from './steps/Step3'
import {getProtocolById, getProtocols} from '../../protocol/core/_requests'
import {Protocol} from '../../protocol/core/_models'
import {receiveProposals} from '../../proposals/core/_requests'

import './steps/Steps.scss'
import {Proposal} from '../../proposals/core/_models'

type Props = {
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({show, handleClose}: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<IReceptionCreate>(defaultReceptionCreate)
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [searchedProposals, setSearchedProposals] = useState<Proposal[]>([])

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const updateData = (fieldsToUpdate: Partial<IReceptionCreate>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }

  const getProtocolByNumber = async (protocol: string): Promise<Protocol> => {
    const protocols = await getProtocols(1, 1, {numero: protocol})

    if (protocols.data.length === 0) {
      return {}
    }

    const prot = await getProtocolById(protocols.data[0].id)

    return prot
  }

  const checkProtocol = async (): Promise<boolean> => {
    if (!data.protocol) {
      return Promise.resolve(false)
    }

    const protocol = await getProtocolByNumber(data.protocol)

    if (protocol.status !== 'em trânsito') {
      setErrorMessage('Protocolo já recepcionado!')
      return Promise.resolve(false)
    }

    if (!protocol.numero || protocol.propostas?.length === 0) {
      setErrorMessage('Protocolo não encontrado ou sem propostas vinculadas.')
      return Promise.resolve(false)
    }

    protocol.propostas && setSearchedProposals([...searchedProposals, ...protocol.propostas])

    updateData({
      protocol: protocol.numero,
      proposals: protocol.propostas,
    })

    return Promise.resolve(true)
  }

  const checkAppDataBase = (): boolean => {
    return true
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
  }

  const nextStep = async () => {
    setHasError(false)
    if (!stepper.current) {
      return
    }

    if (stepper.current.getCurrentStepIndex() === 1) {
      const isProtocolValid = await checkProtocol()

      if (data.protocol === '') {
        setErrorMessage('Preenchimento do número de protocolo é obrigatório')
        setHasError(true)
        return
      }

      if (!isProtocolValid) {
        setHasError(true)
        return
      }
    }

    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkAppDataBase()) {
        setHasError(true)
        return
      }
    }

    stepper.current.goNext()
  }

  const newProtocolRecieve = () => {
    // updateData(defaultReceptionCreate)
    updateData({...data, protocol: '', proposals: []})
    stepper.current?.goFirst()
  }

  const submit = async () => {
    await receiveProposals(data.selectedProposals)

    handleClose()
    // window.location.reload()
  }

  useEffect(() => {
    console.log('data', data)
  }, [data])

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered'
      fullscreen
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
    >
      <div className='modal-header'>
        <h2>Recepção de malote</h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTIcon className='fs-1' iconName='cross' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          {/* begin::Aside*/}
          <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
            {/* begin::Nav*/}
            <div className='stepper-nav ps-lg-10'>
              {/* begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Protocolos</h3>

                    <div className='stepper-desc'>Protocolos recebidos</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 1*/}

              {/* begin::Step 2*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>
                  {/* begin::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Conferência</h3>

                    <div className='stepper-desc'>Selecionar propostas recepcionadas</div>
                  </div>
                  {/* begin::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 2*/}

              {/* begin::Step 3*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Revisão e conclusão</h3>

                    <div className='stepper-desc'>Revisar e concluir recebimento</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 3*/}
            </div>
            {/* end::Nav*/}
          </div>
          {/* begin::Aside*/}

          {/*begin::Content */}
          <div className='flex-row-fluid py-lg-5 px-lg-15'>
            {/*begin::Form */}
            <form noValidate id='kt_modal_create_app_form'>
              <Step1
                data={data}
                updateData={updateData}
                hasError={hasError}
                errorMessage={errorMessage}
              />
              <Step2
                data={data}
                updateData={updateData}
                hasError={hasError}
                errorMessage={errorMessage}
              />
              <Step3
                data={data}
                updateData={updateData}
                hasError={hasError}
                errorMessage={errorMessage}
                searchedProposals={searchedProposals}
              />
              {/* <Step4 data={data} updateData={updateData} hasError={hasError} />
              <Step5 /> */}

              {/*begin::Actions */}
              <div className='d-flex flex-stack pt-10'>
                <div className='me-2'>
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                  >
                    <KTIcon iconName='arrow-left' className='fs-3 me-1' /> Voltar
                  </button>
                </div>
                <div>
                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='submit'
                    onClick={submit}
                  >
                    Enviar <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                  </button>

                  <button
                    type='button'
                    className='btn btn-lg btn-primary new-protocol-receive-btn'
                    data-kt-stepper-action='next'
                    onClick={newProtocolRecieve}
                  >
                    Novo protocolo
                  </button>

                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='next'
                    onClick={nextStep}
                  >
                    Próximo <KTIcon iconName='arrow-right' className='fs-3 ms-1 me-0' />
                  </button>
                </div>
              </div>
              {/*end::Actions */}
            </form>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export {CreateAppModal}
